module.exports = __webpack_public_path__ + "static/img/企业logo5.9b9c34fe.png";